import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[parcelStrategy]'
})
export class ParcelStrategyDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
